import React from 'react';
import { Link } from 'gatsby';
import logo from '@images/icons/logo-blue.svg';
import * as styles from './index.module.css';

export function Logo() {
  return (
    <Link to="/">
      <img className={styles.logo} src={logo} alt="logo" />
    </Link>
  );
}
